import en from './en.json';
import hi from './hi.json';
import ta from './ta.json';
import te from './te.json';
import bn from './bn.json';
import type { Locale } from './locales';

export type Dictionary = typeof en;

const DICTIONARIES: Record<Locale, Dictionary> = {
  en,
  hi,
  ta,
  te,
  bn,
};

export function getDictionary(locale: Locale): Dictionary {
  return DICTIONARIES[locale] ?? DICTIONARIES.en;
}

type DotPath<T, P extends string = ''> = {
  [K in keyof T & string]: T[K] extends Record<string, unknown>
    ? DotPath<T[K], `${P}${K}.`>
    : `${P}${K}`;
}[keyof T & string];

export type StringKey = DotPath<Dictionary>;

function getByPath(obj: Record<string, unknown>, path: string): unknown {
  const parts = path.split('.');
  let current: unknown = obj;
  for (const part of parts) {
    if (current == null || typeof current !== 'object') return undefined;
    current = (current as Record<string, unknown>)[part];
  }
  return current;
}

export function translate(locale: Locale, key: StringKey, vars?: Record<string, string | number>): string {
  const dict = getDictionary(locale);
  const fallback = getDictionary('en');
  let value: unknown = getByPath(dict as Record<string, unknown>, key);
  if (value == null || typeof value !== 'string') {
    value = getByPath(fallback as Record<string, unknown>, key);
  }
  if (typeof value !== 'string') return key;
  if (!vars) return value;
  return value.replace(/\{\{(\w+)\}\}/g, (_, name) => String(vars[name] ?? `{{${name}}}`));
}
